import { Translate } from '../translations';
import type { errorHandler } from '@wix/essentials';
import type { deleteUserDefinedFields } from '@wix/bex-utils/@wix/ambassador-data-extensions-v1-data-extension-schema/http';

export const deleteUserDefinedFieldsErrors = ({
  translate: t,
}: {
  translate: Translate;
}): errorHandler.ErrorCodesMap<typeof deleteUserDefinedFields> => {
  return {
    INVALID_NAMESPACE: () => ({
      message: t(
        'cairo.customFields.updateDataExtension.invalid-namespace.error',
      ),
      action: {
        text: t('cairo.error.contactSupport.cta'),
        onClick: () => {},
      },
    }),
    FQDN_NOT_FOUND: () => ({
      message: t('cairo.customFields.updateDataExtension.fqdn-not-found.error'),
      action: {
        text: t('cairo.error.contactSupport.cta'),
        onClick: () => {},
      },
    }),
    REMOVING_FIELDS_IS_DISALLOWED: () => ({
      message: t(
        'cairo.customFields.updateDataExtension.removing-fields-not-allowed.error',
      ),
      action: {
        text: t('cairo.error.contactSupport.cta'),
        onClick: () => {},
      },
    }),
  };
};
